import './App.css'
import AppBar from '@mui/material/AppBar'
import {
  ThemeProvider,
  CssBaseline,
  Toolbar,
  Typography
} from '@mui/material'

import {
  NotificationsProvider
} from '@toolpad/core/useNotifications'
import { createTheme } from '@mui/material/styles'
import logo from './assets/images/logo.png'
// import MainContent from './sections/MainContent'
import { BrowserRouter } from 'react-router'
import { CaptchaTokenProvider } from './context/CaptchaContext'
import MainNavigator from './navigators/MainNavigator'
import React from 'react'

const theme = createTheme({
  palette: {
    primary: {
      light: '#757ce8',
      main: '#1565C0',
      dark: '#002884',
      contrastText: '#fff'
    },
    secondary: {
      light: '#EDF5FF',
      main: '#B8D9FF',
      dark: '#ba000d',
      contrastText: '#000'
    },
    divider: '#ABABAB',
    grey1: '#515151'
  },
  typography: {
    fontFamily: 'Poppins, Roboto, Arial, sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 600
    },
    body1: {
      fontSize: '1rem'
    },
    med_16_500: {
      fontSize: 16,
      fontWeight: 500
    },
    med_14_500: {
      fontSize: 14,
      fontWeight: 500
    },
    semi_bold_14_600: {
      fontSize: 14,
      fontWeight: 600
    },
    med_28_500: {
      fontSize: 28,
      fontWeight: 500
    }
  }
})

function App () {
  return (
    <BrowserRouter>
      <CaptchaTokenProvider>
        <ThemeProvider theme={theme}>
          <NotificationsProvider>
            <CssBaseline />
            <AppBar position='sticky' color='secondary' sx={{ height: '8vh', justifyContent: 'center', backgroundColor: 'white' }}>
              <Toolbar variant='dense'>
                <img src={logo} alt='Rebuild KEBEA Logo' style={{ height: 55, width: 55, marginRight: 15 }} />
                <Typography variant='body1' color='primary' component='div' sx={{ fontWeight: 'bold' }}>
                  REBUILD KEBEA
                </Typography>
              </Toolbar>
            </AppBar>
            <MainNavigator />
            {/* <MainContent /> */}
          </NotificationsProvider>
        </ThemeProvider>
      </CaptchaTokenProvider>
    </BrowserRouter>
  )
}

export default App
